import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ArrowLeft,
  Sparkles,
  UserCheck,
  Database,
  Megaphone,
  ShieldCheck,
  AlertCircle,
  MessageCircle,
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const Responsibility = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sections = [
    { icon: Sparkles, titleKey: 'responsibility.sectionAiUseTitle', textKey: 'responsibility.sectionAiUseText' },
    { icon: UserCheck, titleKey: 'responsibility.sectionReviewTitle', textKey: 'responsibility.sectionReviewText' },
    { icon: Database, titleKey: 'responsibility.sectionDataTitle', textKey: 'responsibility.sectionDataText' },
    { icon: Megaphone, titleKey: 'responsibility.sectionAdsTitle', textKey: 'responsibility.sectionAdsText' },
    { icon: AlertCircle, titleKey: 'responsibility.sectionLimitsTitle', textKey: 'responsibility.sectionLimitsText' },
  ];

  return (
    <div className="hussar-app">
      <header className="hussar-app-header">
        <div className="hussar-app-header-content">
          <Button
            variant="ghost"
            className="hussar-btn-back"
            onClick={() => navigate('/')}
            data-testid="responsibility-back-btn"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="hussar-logo-full" onClick={() => navigate('/')}>
            <img src="/hussarai-logo-full.png" alt="HussarAi" className="hussar-logo-full-img-small" />
          </div>
          <div></div>
        </div>
      </header>

      <div className="hussar-responsibility-page">
        <div className="hussar-responsibility-container">
          <header className="hussar-responsibility-hero">
            <h1 className="hussar-responsibility-title" data-testid="responsibility-title">
              {t('responsibility.pageTitle')}
            </h1>
            <p className="hussar-responsibility-subtitle">{t('responsibility.pageSubtitle')}</p>
            <p className="hussar-responsibility-intro">{t('responsibility.intro')}</p>
          </header>

          <div className="hussar-responsibility-sections">
            {sections.map(({ icon: Icon, titleKey, textKey }) => (
              <Card key={titleKey} className="hussar-responsibility-card" data-testid={`responsibility-${titleKey.replace('responsibility.', '')}`}>
                <div className="hussar-responsibility-card-icon">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="hussar-responsibility-card-body">
                  <h3 className="hussar-responsibility-card-title">{t(titleKey)}</h3>
                  <p className="hussar-responsibility-card-text">{t(textKey)}</p>
                </div>
              </Card>
            ))}
          </div>

          <Card className="hussar-responsibility-contact" data-testid="responsibility-contact">
            <MessageCircle className="hussar-responsibility-contact-icon" />
            <div>
              <h3 className="hussar-responsibility-contact-title">{t('responsibility.questionsTitle')}</h3>
              <p className="hussar-responsibility-contact-text">{t('responsibility.questionsText')}</p>
              <a
                href="https://wa.me/12396993298"
                target="_blank"
                rel="noopener noreferrer"
                className="hussar-responsibility-contact-link"
                data-testid="responsibility-contact-link"
              >
                {t('responsibility.contactLabel')} →
              </a>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Responsibility;
